import type { ReactNode } from 'react'
import type { SyncSaveState } from '@/types'
import { AlertIcon, CheckIcon, ClockIcon, SyncIcon } from '@/components/icons'
import { cx } from './internal/cx'
import './SyncStatus.css'

export type SyncStatusProps = {
  state: SyncSaveState | null
  className?: string
}

type Tone = 'success' | 'info' | 'warning' | 'error' | 'neutral'

/** Canonical Dutch storage/sync copy (contract §8). Never color alone: icon + text. */
const STATE_META: Record<SyncSaveState, { label: string; icon: ReactNode; tone: Tone; spin?: boolean }> = {
  local_saved: { label: 'Op apparaat opgeslagen', icon: <CheckIcon size={14} />, tone: 'neutral' },
  sync_queued: { label: 'Wacht op synchronisatie', icon: <ClockIcon size={14} />, tone: 'warning' },
  syncing: { label: 'Wordt gesynchroniseerd', icon: <SyncIcon size={14} />, tone: 'info', spin: true },
  cloud_saved: { label: 'In cloud opgeslagen', icon: <CheckIcon size={14} />, tone: 'success' },
  sync_failed: { label: 'Synchronisatie mislukt', icon: <AlertIcon size={14} />, tone: 'error' },
}

export function SyncStatus({ state, className }: SyncStatusProps) {
  if (!state) return null
  const meta = STATE_META[state]
  return (
    <span className={cx('ui-sync-status', `ui-sync-status--${meta.tone}`, className)} role="status">
      <span className={cx('ui-sync-status__icon', meta.spin && 'ui-sync-status__icon--spin')}>{meta.icon}</span>
      <span>{meta.label}</span>
    </span>
  )
}
